{
  "common": {
    "cancel": "Cancelar",
    "save": "Guardar",
    "delete": "Apagar",
    "done": "Concluído",
    "edit": "Editar",
    "search": "Procurar",
    "loading": "A carregar…",
    "yes": "Sim",
    "no": "Não",
    "settings": "Definições",
    "back": "Voltar",
    "close": "Fechar",
    "open": "Abrir",
    "copy": "Copiar",
    "restore": "Restaurar",
    "untitled": "Sem título",
    "create": "Criar",
    "revoke": "Revogar",
    "never": "Nunca",
    "tryAgain": "Tentar de novo",
    "reload": "Recarregar",
    "update": "Atualizar",
    "insert": "Inserir",
    "loadingShort": "A carregar",
    "unknown": "Desconhecido",
    "sampleSentence": "A rápida raposa castanha"
  },
  "sidebar": {
    "views": "Vistas",
    "tags": "Etiquetas",
    "edit": "Editar",
    "done": "Concluído",
    "account": "Conta",
    "newNote": "Nova nota",
    "editTag": "Editar etiqueta",
    "tagOptions": "Opções da etiqueta",
    "reorder": "Reordenar {{label}}",
    "showView": "Mostrar {{label}}",
    "hideView": "Ocultar {{label}}",
    "editViews": "Editar vistas",
    "doneEditingViews": "Concluir edição",
    "samplePeep": "O Caliu é…",
    "sampleQuiet": "Um lugar tranquilo onde as tuas ideias vivem e respiram."
  },
  "views": {
    "all": "Todas as notas",
    "today": "Hoje",
    "todo": "Tarefas",
    "pinned": "Fixadas",
    "untagged": "Sem etiquetas",
    "thisWeek": "Esta semana",
    "shared": "Partilhadas por mim",
    "sharedWithMe": "Partilhadas comigo",
    "attachments": "Anexos",
    "trash": "Reciclagem",
    "archive": "Arquivadas"
  },
  "noteList": {
    "empty": "Ainda sem notas",
    "emptySubtitle": "Cria a tua primeira nota para começar.",
    "untitled": "Sem título",
    "selectNote": "Escolhe uma nota",
    "selectNoteHint": "Escolhe uma nota da lista ou cria uma nova.",
    "selectRestoreOrDelete": "Escolhe uma nota para restaurar ou apagar definitivamente",
    "selectSharedToView": "Escolhe uma nota partilhada para a veres",
    "searchPlaceholder": "Procurar notas…",
    "selectNotes": "Selecionar notas",
    "openSidebar": "Abrir barra lateral",
    "cancelSelection": "Cancelar seleção",
    "clearSelection": "Limpar seleção",
    "emptyTrash": "Esvaziar reciclagem",
    "newNote": "Nova nota",
    "noteCount_one": "{{count}} nota",
    "noteCount_other": "{{count}} notas",
    "sortBy": "Ordenar por",
    "preview": "Pré-visualização",
    "modificationDate": "Data de modificação",
    "creationDate": "Data de criação",
    "title": "Título",
    "manual": "Manual",
    "newestOnTop": "Mais recentes em cima",
    "small": "Pequena",
    "medium": "Média",
    "large": "Grande",
    "empty_pinned": "Nada fixado",
    "empty_pinned_subtitle": "Fixa uma nota para a encontrares depressa aqui.",
    "empty_today": "Nada editado hoje",
    "empty_today_subtitle": "As notas que mexeres hoje aparecem aqui.",
    "empty_todo": "Sem tarefas",
    "empty_todo_subtitle": "Notas com tarefas por concluir aparecem aqui.",
    "empty_untagged": "Tudo etiquetado",
    "empty_untagged_subtitle": "Notas sem etiquetas aparecem aqui.",
    "empty_thisWeek": "Nada esta semana",
    "empty_thisWeek_subtitle": "Notas editadas nos últimos 7 dias aparecem aqui.",
    "empty_shared": "Sem notas partilhadas",
    "empty_shared_subtitle": "As notas que partilhares aparecem aqui.",
    "empty_attachments": "Sem anexos",
    "empty_attachments_subtitle": "Notas com imagens ou ficheiros aparecem aqui.",
    "justNow": "Agora mesmo",
    "minutesAgo": "há {{count}} min",
    "today": "Hoje",
    "yesterday": "Ontem",
    "deletedOn": "Apagada a {{date}}",
    "newNoteShortcut": "Nova nota ({{shortcut}})",
    "noContent": "Sem conteúdo",
    "selectUnarchiveOrDelete": "Escolhe uma nota para a desarquivares ou eliminares",
    "view": "Visualização",
    "density": "Densidade",
    "exportAll": "Exportar tudo"
  },
  "editor": {
    "attachmentTooLarge": "Este ficheiro é demasiado grande para anexar. O limite é 100 MB.",
    "placeholder": "Começa a escrever…",
    "noMatchingCommands": "Sem comandos correspondentes",
    "newNote": "nova nota",
    "noResults": "Sem resultados",
    "foldSection": "Recolher secção",
    "unfoldSection": "Expandir secção",
    "dragSection": "Mover secção",
    "presenceLabel": "Também aqui: {{names}}"
  },
  "noteActions": {
    "pin": "Fixar",
    "unpin": "Desafixar",
    "pinToTop": "Fixar no topo",
    "makeReadOnly": "Tornar só de leitura",
    "makeEditable": "Tornar editável",
    "readOnlyNote": "Nota só de leitura",
    "shareNote": "Partilhar nota",
    "share": "Partilhar",
    "publiclyShared": "Partilhada publicamente",
    "privateNote": "Nota privada",
    "linkCreated": "Hiperligação criada",
    "linkCreatedAndCopied": "Hiperligação criada e copiada",
    "linkRevoked": "Hiperligação de partilha revogada",
    "failedToCreateShareLink": "Não foi possível criar a hiperligação de partilha",
    "failedToRevokeShareLink": "Não foi possível revogar a hiperligação de partilha",
    "thisNoteIsPrivate": "Esta nota é privada.",
    "createPublicLink": "Criar hiperligação pública",
    "creatingLink": "A criar hiperligação…",
    "revokeLink": "Revogar hiperligação",
    "revokingLink": "A revogar…",
    "copyLink": "Copiar hiperligação",
    "copyNoteId": "Copiar ID da nota",
    "noteIdCopied": "ID da nota copiado",
    "exportAs": "Exportar como",
    "exportMarkdown": "Markdown",
    "exportPlainText": "Texto simples",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "Falha na exportação",
    "viewHistory": "Ver histórico",
    "duplicate": "Duplicar",
    "duplicateFailed": "Não foi possível duplicar a nota",
    "select": "Selecionar",
    "delete": "Apagar",
    "moveToTrash": "Mover para a reciclagem",
    "archive": "Arquivar",
    "unarchive": "Desarquivar",
    "tags": "Etiquetas",
    "addTag": "Adicionar etiqueta",
    "noTagsYet": "Ainda não há etiquetas",
    "addTagFailed": "Não foi possível adicionar a etiqueta",
    "removeTagFailed": "Não foi possível remover a etiqueta"
  },
  "userMenu": {
    "theme": "Tema",
    "typography": "Tipografia",
    "language": "Idioma",
    "apiKeys": "Chaves API",
    "devices": "Dispositivos",
    "connectedApps": "Apps ligadas",
    "help": "Ajuda",
    "logOut": "Terminar sessão",
    "defaultUserName": "Utilizador Caliu",
    "editName": "Editar nome",
    "nameLabel": "Nome",
    "namePlaceholder": "O seu nome",
    "upgradeToPro": "Mudar para o Caliu Pro",
    "replayOnboarding": "Rever a introdução",
    "logOutTitle": "Terminar sessão?",
    "logOutBody": "As tuas notas ficam neste dispositivo e podes continuar a lê-las e a escrevê-las. Inicia sessão novamente para sincronizar.",
    "logOutPending_one": "{{count}} alteração ainda não foi sincronizada. Fica neste dispositivo até iniciar sessão novamente.",
    "logOutPending_other": "{{count}} alterações ainda não foram sincronizadas. Ficam neste dispositivo até iniciar sessão novamente.",
    "logOutKeep": "Terminar sessão",
    "logOutAndRemove": "Terminar sessão e remover notas"
  },
  "help": {
    "title": "Centro de ajuda",
    "searchPlaceholder": "Pesquisar artigos de ajuda",
    "noResults": "Nenhum artigo corresponde à sua pesquisa.",
    "offline": "A ajuda não está disponível offline. Será carregada da próxima vez que estiver ligado."
  },
  "fonts": {
    "uiFont": "Tipo de letra da interface",
    "body": "Corpo",
    "headings": "Títulos",
    "code": "Código",
    "sans": "Sans",
    "serif": "Serif",
    "mono": "Mono",
    "editor": "Editor",
    "ui": "Interface",
    "reset": "Repor predefinições"
  },
  "themes": {
    "light": "Claro",
    "dark": "Escuro",
    "system": "Sistema"
  },
  "languages": {
    "systemHint": "Detetado pelo dispositivo",
    "names": {
      "en": "Inglês",
      "es": "Espanhol",
      "ca": "Catalão",
      "fr": "Francês",
      "de": "Alemão",
      "it": "Italiano",
      "pt": "Português",
      "nl": "Neerlandês",
      "ja": "Japonês",
      "zh-CN": "Chinês (simplificado)",
      "ko": "Coreano",
      "zh-TW": "Chinês (tradicional)",
      "ru": "Russo"
    }
  },
  "bulkActions": {
    "pinSelected": "Fixar selecionadas",
    "unpinSelected": "Desafixar selecionadas",
    "pin": "Fixar",
    "addTag": "Adicionar etiqueta",
    "filterTags": "Filtrar etiquetas…",
    "noTagsFound": "Sem etiquetas",
    "exportSelected": "Exportar selecionadas",
    "restoreSelected": "Restaurar selecionadas",
    "deletePermanently": "Apagar definitivamente",
    "moveToTrash": "Mover para a reciclagem",
    "archiveSelected": "Arquivar selecionadas",
    "unarchiveSelected": "Desarquivar selecionadas",
    "exportingTitle": "A exportar as tuas notas",
    "exportingBody": "Isto pode demorar um momento. Mantém este separador aberto até terminar.",
    "exportingProgress": "{{done}} de {{total}}"
  },
  "commandPalette": {
    "placeholder": "Procurar notas, etiquetas, comandos…",
    "noResults": "Sem resultados para «{{query}}»",
    "currentNote": "Nota atual",
    "navigation": "Navegação",
    "notes": "Notas",
    "tags": "Etiquetas",
    "newNote": "Nova nota",
    "allNotes": "Todas as notas",
    "todaysNotes": "Notas de hoje",
    "todo": "Tarefas",
    "pinnedNotes": "Notas fixadas",
    "trash": "Reciclagem",
    "importNotes": "Importar notas",
    "changeTheme": "Mudar tema",
    "keyboardShortcuts": "Atalhos de teclado",
    "pinNote": "Fixar nota",
    "unpinNote": "Desafixar nota",
    "restoreNote": "Restaurar nota",
    "copyShareLink": "Copiar hiperligação de partilha",
    "makePrivate": "Tornar privada",
    "toggleFullscreen": "Ecrã inteiro",
    "noteInfo": "Informação da nota",
    "moveToTrash": "Mover para a reciclagem",
    "archiveNote": "Arquivar nota",
    "unarchiveNote": "Desarquivar nota",
    "archive": "Arquivadas"
  },
  "noteHistory": {
    "title": "Histórico da nota",
    "requiresConnection": "O histórico precisa de ligação à Internet.",
    "reconnect": "Liga-te à Internet e tenta novamente.",
    "noHistory": "Esta nota ainda não tem histórico.",
    "windowMerged": "As edições feitas dentro de 5 minutos são juntas numa só entrada.",
    "selectVersion": "Escolhe uma versão para pré-visualizar",
    "encrypted": "Captura cifrada",
    "encryptedHint": "Esta versão foi guardada com cifragem ponta a ponta. Abre a nota para veres o conteúdo atual.",
    "restoreVersion": "Restaurar esta versão?",
    "restoreVersionHint": "Substitui o conteúdo atual da nota pela versão de {{date}}.",
    "current": "Atual",
    "created": "Criada",
    "trashed": "Apagada",
    "restored": "Restaurada",
    "edited": "Editada"
  },
  "apiKeys": {
    "title": "Chaves API",
    "empty": "Ainda sem chaves API.",
    "emptyHint": "Cria uma para começares a usar a API.",
    "created": "Criada a {{date}}",
    "lastUsed": "Último uso: {{date}}",
    "revokeKey": "Revogar chave",
    "viewApiDocs": "Ver documentação da API",
    "newApiKey": "Nova chave API",
    "apiKeyCreated": "Chave API criada",
    "createApiKey": "Criar chave API",
    "copyHint": "Copia esta chave agora. Não a vais poder ver outra vez.",
    "copyToClipboard": "Copiar para a área de transferência",
    "keyName": "Nome da chave",
    "keyNamePlaceholder": "p. ex. O meu script, Integração Zapier",
    "createKey": "Criar chave",
    "revokeKeyTitle": "Revogar chave API",
    "revokeKeyHint": "Isto revoga esta chave API definitivamente. Qualquer aplicação que a esteja a usar perde o acesso de imediato.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "Apps ligadas",
    "empty": "Ainda sem apps ligadas.",
    "emptyHint": "Liga o Claude, o ChatGPT ou outro assistente de IA para usares as tuas notas a partir do chat. A secção Caliu com IA, em Ajuda, explica como.",
    "connected": "Ligada a {{date}}",
    "lastUsed": "Último uso: {{date}}",
    "revoke": "Revogar",
    "revokeTitle": "Revogar ligação",
    "revokeHint": "Isto revoga o acesso de <strong>{{name}}</strong> à tua conta Caliu e apaga as credenciais que estava a usar. Perde o acesso de imediato.",
    "thisApp": "esta app",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "Escrita",
    "metadata": "Metadados",
    "words": "Palavras",
    "characters": "Caracteres",
    "paragraphs": "Parágrafos",
    "readTime": "Tempo de leitura",
    "minutes": "{{count}} min",
    "tags": "Etiquetas",
    "outgoingLinks": "Ligações de saída",
    "backlinks": "Retroligações",
    "created": "Criada",
    "modified": "Modificada",
    "noteStatistics": "Estatísticas da nota",
    "identifier": "Identificador"
  },
  "inspector": {
    "tabInfo": "Info",
    "tabOutline": "Esquema",
    "tabHistory": "Histórico",
    "dates": "Datas",
    "noHeadings": "Sem títulos nesta nota",
    "noBacklinks": "Nenhuma nota liga para aqui",
    "noOutgoing": "Esta nota não liga a nada",
    "noAttachments": "Sem anexos nesta nota",
    "historyOffline": "O histórico de versões precisa de ligação à Internet",
    "historyLoadMore": "Carregar mais"
  },
  "devices": {
    "title": "Dispositivos",
    "offline": "Estás offline.",
    "offlineHint": "Liga-te à Internet para veres os teus dispositivos.",
    "noSessions": "Não foram encontradas sessões ativas.",
    "thisDevice": "Este dispositivo",
    "lastUsed": "Última utilização: {{date}}",
    "created": "Criado: {{date}}",
    "signOutCurrent": "Terminar sessão neste dispositivo",
    "signOut": "Terminar sessão",
    "confirmCurrentTitle": "Terminar sessão neste dispositivo?",
    "confirmRevokeTitle": "Revogar o dispositivo?",
    "confirmCurrentBody": "Vais terminar sessão no Caliu neste navegador e as notas são removidas deste dispositivo. Inicia sessão outra vez quando quiseres e voltam a partir da tua conta.",
    "confirmRevokeBody": "O dispositivo terminará sessão imediatamente. As alterações não sincronizadas permanecerão lá até voltares a iniciar sessão.",
    "revoke": "Revogar"
  },
  "errorScreen": {
    "title": "Algo correu mal",
    "defaultMessage": "Ocorreu um erro inesperado. Tenta recarregar a página."
  },
  "importModal": {
    "title": "Importar notas",
    "dropToImport": "Larga aqui para importar",
    "dropOrClick": "Larga ficheiros ou clica para procurar",
    "removeFile": "Remover ficheiro",
    "keepNote": "Para o Google Keep, exporta um ZIP do Takeout e envia esse arquivo diretamente.",
    "importedCount_one": "Importada <strong>{{count}}</strong> nota",
    "importedCount_other": "Importadas <strong>{{count}}</strong> notas",
    "fromSource": " do {{source}}",
    "importing": "A importar…",
    "importN": "Importar {{count}} ficheiros",
    "importBtn": "Importar"
  },
  "share": {
    "shareNote": "Partilhar nota",
    "publiclySharedAria": "A nota está partilhada publicamente",
    "copyLink": "Copiar ligação",
    "revokingLink": "A revogar…",
    "revokeLink": "Revogar ligação",
    "creatingLink": "A criar ligação…",
    "createPublicLink": "Criar ligação pública",
    "shareThisNotePublicly": "Partilhar esta nota publicamente",
    "thisNoteIsPrivate": "Esta nota é privada.",
    "publiclyShared": "Partilhada publicamente",
    "privateNote": "Nota privada"
  },
  "shortcuts": {
    "searchPlaceholder": "Procurar atalhos…",
    "pressNew": "Carrega no novo atalho…",
    "resetToDefault": "Repor predefinição",
    "noMatches": "Nenhum atalho corresponde a «<strong>{{query}}</strong>»",
    "navigate": "navegar",
    "edit": "editar",
    "closeAction": "fechar",
    "resetAll": "Repor tudo"
  },
  "tagEditor": {
    "icon": "Ícone",
    "color": "Cor",
    "searchIcons": "Pesquisar ícones",
    "noIcons": "Nenhum ícone corresponde",
    "categories": {
      "essentials": "Essenciais",
      "work": "Trabalho e tecnologia",
      "ideas": "Ideias e criatividade",
      "life": "Pessoas e casa",
      "travel": "Viagens e natureza",
      "fun": "Comida, saúde e lazer"
    }
  },
  "tagActions": {
    "pin": "Fixar etiqueta",
    "unpin": "Desafixar etiqueta",
    "rename": "Mudar o nome…",
    "renameTitle": "Mudar o nome da etiqueta",
    "renameConfirm": "Mudar o nome",
    "renameHint": "A etiqueta é atualizada em todas as notas que a usam, incluindo as arquivadas e as do lixo.",
    "renamed": "Nome da etiqueta alterado",
    "nameInUse": "Esse nome já está em uso",
    "invalidName": "Os nomes das etiquetas só podem ter letras, números, espaços, hífenes e sublinhados",
    "pinFailed": "Não foi possível atualizar a etiqueta",
    "renameFailed": "Não foi possível mudar o nome da etiqueta",
    "editAppearance": "Editar aparência"
  },
  "auth": {
    "appName": "Caliu",
    "or": "ou",
    "email": "E-mail",
    "emailPlaceholder": "tu@exemplo.com",
    "password": "Palavra-passe",
    "passwordPlaceholder": "Palavra-passe",
    "name": "Nome",
    "namePlaceholder": "O teu nome",
    "confirmPassword": "Confirmar palavra-passe",
    "newPassword": "Nova palavra-passe",
    "confirmNewPassword": "Confirmar nova palavra-passe",
    "signInSubtitle": "Inicia sessão na tua conta",
    "createAccountSubtitle": "Cria a tua conta",
    "forgotPassword": "Esqueceste-te da palavra-passe?",
    "signingIn": "A iniciar sessão…",
    "signIn": "Iniciar sessão",
    "noAccount": "Não tens conta?",
    "signUp": "Criar conta",
    "haveAccount": "Já tens conta?",
    "creatingAccount": "A criar conta…",
    "createAccount": "Criar conta",
    "googleSignUpAria": "Regista-te com Google",
    "signupClosedTitle": "O registo está fechado de momento",
    "signupClosedBody": "O Caliu está em beta privada. Junta-te à lista de espera em caliuapp.com para acesso antecipado.",
    "joinWaitlist": "Juntar-me à lista de espera",
    "forgotTitle": "Repor palavra-passe",
    "forgotSubtitle": "Indica o teu e-mail e enviamos-te um link de reposição.",
    "sendResetLink": "Enviar link de reposição",
    "sending": "A enviar…",
    "checkYourEmail": "Verifica o teu e-mail",
    "resetLinkSentPrefix": "Se ",
    "resetLinkSentSuffix": " tem uma conta, enviámos um link de reposição. Expira dentro de 1 hora.",
    "backToSignIn": "Voltar ao início de sessão",
    "verifySentPrefix": "Enviámos um link de verificação para ",
    "verifySentSuffix": ". Clica nele para ativar a tua conta.",
    "linkExpires10m": "O link expira em 10 minutos.",
    "resending": "A reenviar…",
    "resendEmail": "Reenviar e-mail",
    "wrongEmail": "E-mail errado?",
    "goBack": "Voltar",
    "invalidResetLinkTitle": "Link de reposição inválido",
    "invalidResetLinkBody": "Este link é inválido ou expirou.",
    "requestNewLink": "Pedir um link novo",
    "setNewPasswordTitle": "Definir nova palavra-passe",
    "setNewPasswordHint": "Escolhe uma palavra-passe forte.",
    "updatingPassword": "A atualizar…",
    "updatePassword": "Atualizar palavra-passe",
    "localNotesTitle": "Tem notas neste dispositivo",
    "localNotesBody_one": "Escreveste {{count}} nota aqui antes de iniciar sessão. O que fazemos com ela?",
    "localNotesBody_other": "Escreveste {{count}} notas aqui antes de iniciar sessão. O que fazemos com elas?",
    "localNotesDelete": "Eliminá-las",
    "localNotesMerge": "Adicioná-las à minha conta",
    "backToMyNotes": "Voltar às minhas notas",
    "errorGoogleAuthFailed": "Não foi possível iniciar sessão com o Google. Tenta novamente.",
    "errorInvalidToken": "Link de verificação inválido. Regista-te novamente.",
    "errorEmailTaken": "Este email já está em uso. Inicia sessão.",
    "signInInstead": "Inicia sessão nessa conta",
    "errorIdentityTaken": "Essa identidade já pertence a outra conta Caliu. Inicia sessão nessa conta.",
    "parkedNotesTitle": "Notas de outra conta",
    "parkedNotesBody_one": "Inicia sessão em {{email}} para manteres as notas dessa conta neste dispositivo. Outra conta apaga a única nota que está aqui, incluindo o que tenha sido escrito depois.",
    "parkedNotesBody_other": "Inicia sessão em {{email}} para manteres as notas dessa conta neste dispositivo. Outra conta apaga as {{count}} notas que estão aqui, incluindo o que tenha sido escrito depois.",
    "parkedNotesBodyNoEmail_one": "Inicia sessão na conta da qual terminaste sessão para manteres as notas dessa conta neste dispositivo. Outra conta apaga a única nota que está aqui, incluindo o que tenha sido escrito depois.",
    "parkedNotesBodyNoEmail_other": "Inicia sessão na conta da qual terminaste sessão para manteres as notas dessa conta neste dispositivo. Outra conta apaga as {{count}} notas que estão aqui, incluindo o que tenha sido escrito depois.",
    "parkedNotesContinue": "Continuar"
  },
  "connectors": {
    "wantsAccess": "quer aceder ao Caliu",
    "couldntLoad": "Não foi possível carregar este pedido",
    "authorize": "Autorizar",
    "keepHappeningHint": "Se isto continuar a acontecer, remove o conector do teu cliente MCP e adiciona-o novamente.",
    "backToCaliu": "Voltar ao Caliu",
    "askingPermissionPrefix": "está a pedir permissão para ler e modificar as tuas notas e etiquetas através do servidor MCP do Caliu.",
    "signedInAs": "Sessão iniciada como {{name}}.",
    "permissions": "Permissões",
    "deny": "Recusar",
    "allow": "Permitir"
  },
  "editorTypography": {
    "fontSize": "Tamanho da fonte",
    "lineHeight": "Altura da linha",
    "paragraphSpacing": "Espaçamento entre parágrafos"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Shift"
  },
  "floatingMenu": {
    "undo": "Desfazer",
    "redo": "Refazer",
    "taskList": "Lista de tarefas",
    "bulletList": "Lista com marcadores",
    "orderedList": "Lista numerada",
    "blockQuote": "Citação em bloco",
    "separator": "Separador",
    "insertTag": "Inserir etiqueta",
    "highlight": "Destacar",
    "math": "Fórmula",
    "removeHighlight": "Remover destaque",
    "inlineCode": "Código em linha",
    "codeBlock": "Bloco de código",
    "insertTable": "Inserir tabela",
    "insertImage": "Inserir imagem",
    "hideStyleBar": "Ocultar barra de estilo",
    "attachFile": "Anexar ficheiro",
    "photoLibrary": "Fototeca",
    "camera": "Câmara",
    "fromFile": "De um ficheiro"
  },
  "imageDialog": {
    "title": "Inserir imagem",
    "tabUpload": "Ficheiro",
    "tabUrl": "URL",
    "urlLabel": "URL da imagem",
    "urlPlaceholder": "https://exemplo.com/imagem.jpg",
    "altLabel": "Texto alternativo",
    "altPlaceholder": "Descreve a imagem…",
    "previewAlt": "pré-visualização",
    "changeImage": "Mudar imagem",
    "dropToInsert": "Larga aqui para inserir",
    "dropOrClick": "Larga uma imagem ou clica para procurar",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "Inserir imagem"
  },
  "linkDialog": {
    "editTitle": "Editar ligação",
    "insertTitle": "Inserir ligação",
    "textLabel": "Texto",
    "textPlaceholder": "Texto da ligação",
    "urlPlaceholder": "https://exemplo.com",
    "removeLink": "Remover ligação",
    "openLink": "Abrir ligação",
    "editLink": "Editar ligação"
  },
  "noteEditor": {
    "notFound": "Nota não encontrada.",
    "inTrashBanner": "Esta nota está na reciclagem. Restaura-a para editares.",
    "restore": "Restaurar",
    "noContent": "Esta nota não tem conteúdo."
  },
  "noteHeader": {
    "noteInfo": "Informações da nota"
  },
  "table": {
    "deleteRow": "Eliminar linha",
    "deleteTable": "Eliminar tabela",
    "addRow": "Adicionar linha",
    "addRowAbove": "Adicionar linha acima",
    "addColumn": "Adicionar coluna",
    "addColumnBefore": "Adicionar coluna antes",
    "moveRowUp": "Mover linha para cima",
    "moveRowDown": "Mover linha para baixo",
    "moveColumnLeft": "Mover coluna para a esquerda",
    "moveColumnRight": "Mover coluna para a direita",
    "deleteColumn": "Eliminar coluna",
    "actions": "Ações da tabela"
  },
  "syncIndicator": {
    "synced": "Sincronizado",
    "pending_one": "{{count}} sincronização pendente",
    "pending_other": "{{count}} sincronizações pendentes",
    "offline": "Sem ligação",
    "offlinePending_one": "Sem ligação · {{count}} pendente",
    "offlinePending_other": "Sem ligação · {{count}} pendentes",
    "syncing": "A sincronizar...",
    "conflict_one": "{{count}} conflito",
    "conflict_other": "{{count}} conflitos",
    "error": "Erro de sincronização",
    "syncedTooltip": "Todas as alterações guardadas",
    "pendingTooltip_one": "{{count}} alteração a aguardar sincronização",
    "pendingTooltip_other": "{{count}} alterações a aguardar sincronização",
    "offlineTooltip": "Sem ligação: as alterações serão sincronizadas quando voltares a ter ligação",
    "offlinePendingTooltip_one": "Sem ligação: {{count}} alteração será sincronizada quando voltares a ter ligação",
    "offlinePendingTooltip_other": "Sem ligação: {{count}} alterações serão sincronizadas quando voltares a ter ligação",
    "syncingTooltip": "A sincronizar...",
    "syncingPendingTooltip_one": "A sincronizar {{count}} alteração pendente...",
    "syncingPendingTooltip_other": "A sincronizar {{count}} alterações pendentes...",
    "conflictTooltip_one": "{{count}} nota tem alterações em conflito. Clica para resolver.",
    "conflictTooltip_other": "{{count}} notas têm alterações em conflito. Clica para resolver.",
    "errorTooltip": "A sincronização falhou. Será repetida automaticamente.",
    "conflictsTitle": "Resolver conflitos",
    "local": "Neste dispositivo",
    "localTooltip": "Apenas neste dispositivo. Inicia sessão para sincronizar."
  },
  "image": {
    "download": "Transferir imagem",
    "replace": "Substituir imagem",
    "remove": "Remover imagem"
  },
  "sharePage": {
    "goToCaliu": "Ir para o Caliu",
    "noteNotFoundTitle": "Nota não encontrada",
    "somethingWentWrong": "Algo correu mal",
    "lastUpdated": "Última atualização: {{date}}",
    "tagline": "Uma app de notas para pensadores",
    "subtagline": "Escreve em markdown. Sincroniza em todo o lado. Pensa com clareza.",
    "startWriting": "Começar a escrever",
    "signIn": "Iniciar sessão",
    "openInCaliu": "Abrir no Caliu",
    "adding": "A adicionar…",
    "addToSharedList": "Adicionar à minha lista partilhada",
    "notFoundSubtitle": "Esta ligação partilhada pode ter expirado ou sido revogada.",
    "errorSubtitle": "Não foi possível carregar esta nota. Tenta de novo."
  },
  "sharedView": {
    "loading": "A carregar nota partilhada…",
    "sharedWithYou": "Partilhada consigo",
    "viewRaw": "Ver Markdown em bruto",
    "viewRendered": "Ver nota formatada",
    "copyMarkdown": "Copiar Markdown",
    "markdownCopied": "Markdown copiado",
    "copyFailed": "Falha ao copiar",
    "notLoadedYet": "Esta nota ainda não foi carregada",
    "linkCopied": "Ligação copiada",
    "actions": "Ações da nota"
  },
  "sharedWithMe": {
    "title": "Partilhadas comigo",
    "removeFromList": "Remover da lista",
    "empty": "Ainda não há notas partilhadas",
    "emptyHint": "Abre uma ligação partilhada do Caliu de um amigo para a adicionares aqui. As notas partilhadas sincronizam-se nos teus dispositivos."
  },
  "trashView": {
    "empty": "A reciclagem está vazia",
    "emptyHint": "As notas eliminadas aparecerão aqui",
    "retention": "As notas na reciclagem são eliminadas definitivamente após 30 dias",
    "trash": "Reciclagem"
  },
  "fileAttachment": {
    "download": "Transferir ficheiro",
    "remove": "Remover ficheiro"
  },
  "archiveView": {
    "archive": "Arquivadas",
    "empty": "O arquivo está vazio",
    "emptyHint": "As notas arquivadas aparecerão aqui",
    "archivedOn": "Arquivada em {{date}}"
  },
  "pro": {
    "subtitle": "Caliu, sem limites.",
    "features": [
      "Notas ilimitadas",
      "Histórico de versões de notas",
      "Exporta para PDF, HTML, RTF, ePub + em massa",
      "Todos os temas, fontes e ícones de app",
      "Apoia o desenvolvimento do Caliu"
    ],
    "perMonth": "{{price}} por mês",
    "perWeek": "{{price}} por semana",
    "oneTime": "{{price}} pagamento único",
    "perYear": "{{price}} por ano",
    "or": "ou",
    "signInToSubscribe": "Inicia sessão para subscrever",
    "accountRequired": "O Caliu Pro está associado à tua conta, por isso é desbloqueado em todos os dispositivos.",
    "plansUnavailable": "Não foi possível carregar os planos. Verifica a ligação e tenta novamente.",
    "yearly": "Anual",
    "monthly": "Mensal",
    "continue": "Continuar",
    "bestValue": "Melhor valor",
    "autoRenew": "{{amount}}. Renova automaticamente até cancelares. Cancela quando quiseres.",
    "freeTrial": "Grátis durante {{count}} dias",
    "billedSubtitle": "Grátis durante {{count}} dias, depois {{amount}}. Cancela quando quiseres.",
    "startTrial": "Iniciar teste gratuito",
    "upgradeSubtitle": "Histórico de versões, todos os temas e tipos de letra, exportação e muito mais.",
    "upgradeNow": "Atualizar agora",
    "thanks": "Obrigado por apoiar o Caliu!",
    "renewsOn": "Renova a {{date}}",
    "endsOn": "Termina a {{date}}",
    "lifetime": "Acesso vitalício",
    "lifetimePlan": "Vitalício",
    "oneTimeNoRenewal": "Pagamento único",
    "launchPrice": "Preço de lançamento. Mais tarde subirá para {{price}}.",
    "buy": "Comprar",
    "oneTimeDisclosure": "{{amount}}. Pagamento único, sem renovação.",
    "thanksMessage": "O teu apoio mantém o Caliu independente e privado.",
    "manageSubscription": "Gerir subscrição",
    "contactUs": "Dúvidas? Fala connosco",
    "grandfatheredNote": "Como apoiante inicial, o Caliu Pro é teu para sempre. Nada para renovar.",
    "webFootnote": "A exportação para PDF ainda não está disponível na web.",
    "active": "Ativa"
  },
  "find": {
    "placeholder": "Procurar na nota",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "Sem resultados",
    "next": "Correspondência seguinte",
    "previous": "Correspondência anterior",
    "close": "Fechar"
  },
  "conflicts": {
    "description": "Esta nota foi editada noutro dispositivo. Mantenha uma versão.",
    "yours": "A sua versão",
    "theirs": "A outra versão",
    "step": "{{current}} de {{total}}",
    "keepYours": "Manter a sua",
    "keepTheirs": "Manter a outra",
    "serverError": "Não foi possível carregar a outra versão.",
    "done": "Todos os conflitos resolvidos.",
    "previous": "Conflito anterior",
    "next": "Conflito seguinte",
    "copyOf": "Cópia de {{title}}"
  },
  "onboarding": {
    "welcomeTitle": "Bem-vindo ao Caliu",
    "welcomeSubtitle": "Um lugar tranquilo onde as tuas ideias podem viver e respirar.",
    "getStarted": "Começar",
    "magicTitle": "Vê as tuas palavras a ganhar forma",
    "magicSubtitle": "Tu escreves texto simples. O Caliu transforma-o em estrutura: tarefas, destaques e etiquetas que se arrumam sozinhas.",
    "magicLearnMore": "Aprende o essencial do Markdown",
    "replay": "Repetir",
    "demoTitle": "Verão à beira-mar",
    "demoBody": "Planear uma **semana calma** numa vila pequena.",
    "demoTask": "Reservar a casinha",
    "demoHighlight": "Nadar ==antes== do pequeno-almoço",
    "demoTags": "#verão #planos",
    "intentTitle": "O que vais trazer para aqui?",
    "intentSubtitle": "Escolhe alguns. A tua primeira nota e as tuas etiquetas vão estar à tua espera, já tuas.",
    "themeTitle": "Escolhe a tua luz",
    "themeSubtitle": "Temas a condizer com o ambiente da tua escrita.",
    "proTitle": "Começa com tudo",
    "proSubtitle": "Começa com tudo desde o primeiro dia. Experimenta grátis e fica com ele só se merecer o seu lugar.",
    "proTrust": "Sem anúncios. Sem truques. Cancela quando quiseres.",
    "tryProFree": "Experimentar o Pro grátis",
    "continueFree": "Continuar com o plano gratuito",
    "allSetTitle": "Está tudo pronto",
    "allSetSubtitle": "Bem-vindo ao Caliu. Faz dele o teu.",
    "startWriting": "Começar a escrever",
    "firstNoteTitle": "Onde tudo começa",
    "firstNoteBody": "Esta é a minha primeira nota. Vive neste dispositivo, funciona offline e segue-me para todo o lado.",
    "firstNoteTask": "Anotar um pensamento que valha a pena guardar",
    "next": "Seguinte",
    "skip": "Saltar",
    "back": "Voltar",
    "intents": {
      "journal": "Diário",
      "ideas": "Ideias",
      "work": "Trabalho",
      "study": "Estudos",
      "reading": "Leitura",
      "plans": "Planos"
    },
    "signInCta": "Inicia sessão ou regista-te",
    "continueWithoutAccount": "Continuar sem conta",
    "backupTitle": "Onde vivem as tuas notas",
    "backupSubtitle": "Começam neste dispositivo. Com uma conta sincronizam, e uma cópia segura chega a todos os teus dispositivos.",
    "syncOffTitle": "A sincronização está desativada",
    "syncOffBody": "Inicia sessão para sincronizar as tuas notas em todos os teus dispositivos.",
    "backupSignedIn": "As tuas notas são sincronizadas em segurança enquanto escreves.",
    "backupStageDevice": "Este dispositivo",
    "backupStageSafe": "Sincronizadas",
    "backupStageEverywhere": "Todos os teus dispositivos",
    "freeNotes": "{{limit}} notas grátis, sem conta, para sempre. O Pro torna-as ilimitadas."
  },
  "backup": {
    "evictionNotice": "Por agora as notas vivem apenas neste navegador. Os navegadores podem limpar os dados do site quando falta espaço.",
    "dismiss": "Dispensar",
    "signIn": "Iniciar sessão"
  },
  "gate": {
    "share": "Inicia sessão para partilhar notas.",
    "history": "Inicia sessão para guardar o histórico de versões.",
    "import": "Inicia sessão para importar notas."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "Código LaTeX"
  },
  "noteLimit": {
    "banner": "{{count}} de {{limit}} notas",
    "paywallTitle": "Chegaste às {{limit}} notas gratuitas",
    "paywallBody": "Editar, pesquisar e sincronizar continuam a funcionar. Move uma nota para a reciclagem para libertar um lugar, ou passa a ilimitado com o Caliu Pro: mensal, anual ou com uma compra única vitalícia.",
    "importCapped": "Só foram importados {{count}} de {{total}} ficheiros: o plano gratuito permite {{limit}} notas."
  },
  "appUpdate": {
    "available": "Está disponível uma nova versão do Caliu."
  },
  "settings": {
    "title": "Definições",
    "account": "Conta",
    "writing": "Escrita",
    "keyboardShortcuts": "Atalhos de teclado",
    "editor": "Editor",
    "yourNotes": "As tuas notas",
    "about": "Acerca de",
    "noAccount": "Sem conta",
    "sendFeedback": "Enviar comentários",
    "signInOrCreate": "Inicia sessão ou regista-te",
    "notesComeWithYou": "As notas deste dispositivo vão contigo.",
    "notSyncing": "Sem sincronização",
    "signInToSync": "Inicia sessão para sincronizar as tuas notas.",
    "sync": "Sincronização",
    "security": "Segurança",
    "communications": "Comunicações",
    "newsletter": "Newsletter da Caliu",
    "newsletterFooter": "Um email curto de vez em quando sobre novas versões e o que está a chegar à Caliu.",
    "newsletterError": "Não foi possível atualizar a newsletter. Tenta novamente.",
    "appearance": "Aparência",
    "themes": "Temas",
    "sizing": "Tamanho",
    "systemDefault": "Predefinição do sistema",
    "separateThemes": "Temas distintos para claro e escuro",
    "maxWidth": "Largura máxima",
    "maxWidthHint": "Centra o texto numa coluna legível em ecrãs largos",
    "markdownReturn": "Return ao estilo Markdown",
    "markdownReturnHint": "Return quebra a linha. Prima Return duas vezes para um novo parágrafo",
    "newNoteStart": "As notas novas começam com",
    "newNoteStartH1": "Título 1",
    "newNoteStartH2": "Título 2",
    "newNoteStartH3": "Título 3",
    "newNoteStartH4": "Título 4",
    "newNoteStartDate": "Data",
    "newNoteStartDateIso": "Data (ISO 8601)",
    "newNoteStartDateTime": "Data e hora",
    "newNoteStartDateTimeIso": "Data e hora (ISO 8601)",
    "newNoteStartEmpty": "Vazia",
    "newNoteStartHint": "Aplica-se às notas que cria na app.",
    "collapsibleSections": "Secções recolhíveis",
    "collapsibleSectionsHint": "Permite recolher um título e o seu conteúdo atrás de uma seta",
    "experimental": "Experimental",
    "general": "Geral"
  },
  "toolbar": {
    "toggleSidebar": "Mostrar/Ocultar barra lateral",
    "toggleInspector": "Mostrar ou ocultar o inspetor",
    "searchNotes": "Procurar notas",
    "newNote": "Nova nota",
    "findInNote": "Procurar na nota",
    "showToolbar": "Mostrar barra de ferramentas",
    "hideToolbar": "Ocultar barra de ferramentas",
    "moreNoteActions": "Mais ações da nota",
    "undo": "Desfazer",
    "redo": "Refazer",
    "zenMode": "Modo Zen",
    "sourceMode": "Modo de origem",
    "richEditor": "Editor enriquecido",
    "sortBy": "Ordenar por",
    "bold": "Negrito",
    "italic": "Itálico",
    "heading": "Título",
    "list": "Lista",
    "link": "Ligação",
    "insert": "Inserir",
    "more": "Mais",
    "strikethrough": "Rasurado",
    "table": "Tabela",
    "horizontalRule": "Linha horizontal",
    "codeBlock": "Bloco de código",
    "inlineCode": "Código em linha",
    "blockQuote": "Citação",
    "math": "Fórmula",
    "highlight": "Destaque",
    "bulletList": "Lista com marcadores",
    "orderedList": "Lista numerada",
    "photoLibrary": "Biblioteca de fotografias",
    "camera": "Câmara",
    "files": "Ficheiros",
    "yellow": "Amarelo",
    "green": "Verde",
    "blue": "Azul",
    "pink": "Rosa",
    "purple": "Roxo",
    "heading1": "Título 1",
    "heading2": "Título 2",
    "heading3": "Título 3",
    "heading4": "Título 4",
    "heading5": "Título 5",
    "heading6": "Título 6",
    "removeHighlight": "Remover destaque"
  },
  "whatsNew": {
    "title": "Novidades",
    "tagIconsTitle": "Ícones desenhados para o Caliu",
    "tagIconsBody": "Todos os ícones da app são novos e foram feitos para o Caliu. Dá a cada etiqueta o seu próprio ícone e pesquisa-os no teu idioma.",
    "newNoteStartTitle": "Começa as notas à tua maneira",
    "newNoteStartBody": "Uma nota nova pode abrir com um título, a data de hoje, a data e a hora, ou uma página em branco. Escolhe-o nas Definições, em Editor.",
    "typographyTitle": "Tipografia, ao ponto exato",
    "typographyBody": "Escolhe o tamanho exato do texto, a altura da linha e o espaçamento entre parágrafos das tuas notas, nas Definições, em Tipografia.",
    "typographySample": "Cada nota segue o tamanho, a altura da linha e o espaçamento que definires, ao ponto.",
    "sampleMorningPages": "Páginas matinais",
    "newsletterTitle": "Chegou a newsletter da Caliu",
    "newsletterBody": "A partir de agora, um email curto conta-te as novidades de cada versão, na tua língua. Ativa-a se quiseres. Podes mudar quando quiseres nas Definições."
  },
  "sharing": {
    "inviteByEmail": "Convidar por e-mail",
    "invite": "Convidar",
    "roleOwner": "Proprietário",
    "roleEditor": "Pode editar",
    "roleViewer": "Pode ver",
    "generalAccess": "Acesso geral",
    "shareWithLink": "Partilhar com uma ligação",
    "accessRestricted": "Apenas as pessoas convidadas",
    "accessView": "Qualquer pessoa com a ligação pode ver",
    "accessEdit": "Qualquer pessoa com a ligação pode editar",
    "remove": "Remover",
    "leave": "Sair",
    "leaveNote": "Sair da nota",
    "leaveConfirmTitle": "Sair desta nota?",
    "leaveConfirmBody": "Desaparece das tuas listas em todos os dispositivos. O proprietário pode voltar a convidar-te.",
    "leaveSelectedTitle": "Sair das notas partilhadas?",
    "leaveSelectedBody_one": "Vais sair de {{count}} nota partilhada contigo. As tuas próprias notas vão para a reciclagem.",
    "leaveSelectedBody_other": "Vais sair de {{count}} notas partilhadas contigo. As tuas próprias notas vão para a reciclagem.",
    "sharedBy": "Partilhada por {{name}}",
    "sharedList": "Partilhadas",
    "viewOnly": "Só leitura",
    "accessNowEditor": "Agora podes editar esta nota.",
    "accessNowViewer": "Agora só podes ver esta nota.",
    "accessRemoved": "Já não tens acesso a esta nota.",
    "unsentSavedAsCopy": "As alterações por enviar foram guardadas numa cópia.",
    "privateNote": "Nota privada",
    "memberLimit": "Uma nota pode ser partilhada com até 50 pessoas.",
    "rateLimit": "Demasiados convites. Tenta mais tarde.",
    "inviteFailed": "Não foi possível enviar os convites. Tenta novamente.",
    "invalidEmail": "Introduz um endereço de e-mail válido.",
    "onlineOnly": "Liga-te à internet para gerir a partilha.",
    "you": "Tu",
    "ownerOnly": "Só o proprietário pode alterar quem tem acesso.",
    "unavailable": "A partilha não está disponível neste momento. Tenta mais tarde.",
    "updateFailed": "Não foi possível atualizar a partilha. Tenta novamente.",
    "inviteInvalid": "Este convite já não é válido.",
    "copyLink": "Copiar ligação",
    "invited": "Convidado",
    "copied": "Copiado",
    "accessRestrictedHint": "Só as pessoas que convidares a podem abrir.",
    "onlyYouHint": "Só tu a podes abrir.",
    "accessViewHint": "Qualquer pessoa com o link a pode ler, sem conta.",
    "accessEditHint": "Qualquer pessoa com o link a pode editar.",
    "roleBelowLink": "Qualquer pessoa com o link pode editar, por isso as pessoas que convidares também podem editar.",
    "inviteAs": "Convidar como",
    "revokeInvite": "Revogar convite",
    "statusPeople_one": "{{count}} pessoa",
    "statusPeople_other": "{{count}} pessoas",
    "publicLink": "Ligação pública",
    "statusFrom": "De {{name}}",
    "removeConfirmTitle": "Remover {{name}}?",
    "removeConfirmBody": "Deixará de ter acesso a esta nota.",
    "revokeConfirmTitle": "Revogar o convite para {{name}}?",
    "revokeConfirmBody": "O link do convite deixará de funcionar.",
    "peopleWithAccess": "Pessoas com acesso",
    "addPeoplePlaceholder": "Adicionar pessoas por e-mail",
    "invitePro": "Convidar pessoas faz parte do Caliu Pro.",
    "inviteKeepsAccess": "As pessoas convidadas mantêm o acesso se desativares a ligação.",
    "youSuffix": "(tu)"
  },
  "noAccess": {
    "title": "Não tens acesso a esta nota",
    "linkBody": "O proprietário não a partilhou contigo. Pede-lhe que te convide ou que ative o link.",
    "signedOutBody": "Inicia sessão com a conta com que foi partilhada.",
    "inviteTitle": "Este convite já não é válido",
    "inviteBody": "Pede um novo à pessoa que te convidou.",
    "removedTitle": "Já não tens acesso a esta nota",
    "removedBody": "O proprietário removeu-te.",
    "removedCopyBody": "O proprietário removeu-te. As tuas alterações por enviar foram guardadas como cópia nas tuas notas.",
    "backToNotes": "Voltar às notas",
    "signIn": "Iniciar sessão"
  }
}
